import { render, staticRenderFns } from "./Bilancioupload.vue?vue&type=template&id=70249c17&"
import script from "./Bilancioupload.vue?vue&type=script&lang=js&"
export * from "./Bilancioupload.vue?vue&type=script&lang=js&"
import style0 from "./Bilancioupload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Bilancioupload.vue"
export default component.exports